<template>
    <!-- List Contacts Page -->
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span>Leads</span>
                    <a>List View</a>
                </div>
                <div class="d-flex flex-wrap align-items-center margin1004 dis-none" :class="{'margin1306':leadsToShow == 'Archive'}">
                    <div class= "d-flex justify-content-between align-items-center mr-1" :class="{'disable-click':selectedLeads.length}" style="width: 210px;">
                        <el-dropdown trigger="click">
                            <a href="javascript:;" class="btn btn-new-green btn-wide" style="padding-left: 14px !important"><img src="/static/images/sort-icon.svg" style="margin-right: 4px;width: 18px;">Sort by<i class="icon-chevron-up ml-2 pl-17 text-white"></i></a>
                            <el-dropdown-menu slot="dropdown" class="leads-list-sort-drop" style="margin-top: 1px;padding: 0px 0px !important;left: 578;">
                                <el-dropdown-item>
                                    <a class="sort-color" @click="callSortMethod('AZ')">Alphabetically (A to Z)<input class="radio-alp pointer" v-model="sort_by" type="radio" id="AZ" name="dropdown" value="AZ"></a>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <a class="sort-color" @click="callSortMethod('ZA')">Alphabetically (Z to A)<input class="radio-alp pointer" v-model="sort_by" type="radio" id="ZA" name="dropdown" value="ZA"></a>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <a class="sort-color" @click="callSortMethod('recent')">Recently Added<input class="radio-add pointer" v-model="sort_by" type="radio" id="recent" name="dropdown" value="recent"></a>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <button class="btn btn-new-primary btn-wide mr-3" v-if="leadsToShow == 'Archive' && userPermissions.leads.permitted_actions.retrieve" :style="selectedLeads.length ? '' : 'background-color: #ababab; border-color: #ababab'" @click="retriveConfirm"><i class="icon icon-arrow-down-bold-box text-white mr-2 fs-18"></i>Revert</button>
                    <!-- <button class="btn btn-new-primary btn-wide px-6 mr-4" @click="$modal.show('columnConfigLeads')"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/column-config.svg" style="margin-right: 8px; margin-top: -2px"> Column Config</button> -->
                    <button class="btn btn-new-primary btn-wide mr-3" @click="showFilters()" :class="{'disable-click':selectedLeads.length}"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;">Filter</button>
                    <button class="btn btn-new-primary btn-wide mr-3 margin545" @click="showBulk" :class="{'disable-click':selectedLeads.length}"><img src="/static/images/bulk-icon.svg" style="margin-right: 8px; margin-top: -2px">Upload Bulk Data</button>
                    <el-tooltip class="item" effect="dark" content="Download Sample Excel Sheet" placement="bottom">
                        <button class="btn btn-new-primary btn-wide mr-3 margin545" :disabled="download_excelsheet" @click="downloadSampleExcelSheet" :class="{'disable-click':selectedLeads.length}" style="width: 40px !important;min-width: 40px !important;padding-left: 10px !important;">
                            <hollow-dots-spinner v-if="download_excelsheet" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                            <img src="/static/images/download_icon.png" width="22" height="22">
                        </button>
                    </el-tooltip>
                    <button class="btn btn-new-primary btn-wide mr-3 margin545" :style="selectedLeads.length ? '' : 'background-color: #ababab; border-color: #ababab; cursor: not-allowed;'" @click="selectedLeads.length ? showDownloadExcelModal() : ''"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/export-excel-white.svg" style="margin-right: 8px; margin-top: -2px"> Export to Excel</button>
                    <button class="btn btn-new-danger btn-wide mr-3 margin876" v-if="leadsToShow != 'Converted' && loggedInUser.user_role == 'sales_manager' && userPermissions.leads.permitted_actions.delete" :style="selectedLeads.length ? '' : 'background-color: #ababab; border-color: #ababab; cursor: not-allowed;'" @click="selectedLeads.length ? $modal.show('deleteLead') : ''"> - Delete</button>
                    <!-- <i class="icon icon-trash text-secondary fs-18 pr-1"></i> -->
                    <button class="btn btn-new-green btn-wide margin1003" v-if="userPermissions.leads.permitted_actions.create" @click="$router.push('/leads/createLeads/new')" :class="{'disable-click':selectedLeads.length,'create-margin':leadsToShow == 'Archive'}" style="background-color: #128807 !important;">+ Create New</button>
                </div>
                <div class="d-flex flex-wrap align-items-center dis-none-ms">
                    <div class= "d-flex justify-content-between align-items-center mr-3" :class="{'disable-click':selectedLeads.length}">
                        <el-dropdown trigger="click">
                            <el-tooltip class="item" effect="dark" content="Sort by" placement="top">
                                <a href="javascript:;" class="btn btn-new-green btn-wide" style="padding-left: 12px !important;width: 40px !important;min-width: 3.8rem !important;"><img src="/static/images/sort-icon.svg" style="margin-right: 4px;width: 18px;"></a>
                            </el-tooltip>
                            <el-dropdown-menu slot="dropdown" class="leads-list-sort-drop" style="margin-top: 1px;padding: 0px 0px !important;left: 578;">
                                <el-dropdown-item>
                                    <a class="sort-color" @click="callSortMethod('AZ')">Alphabetically (A to Z)<input class="radio-alp pointer" v-model="sort_by" type="radio" id="AZ" name="dropdown" value="AZ"></a>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <a class="sort-color" @click="callSortMethod('ZA')">Alphabetically (Z to A)<input class="radio-alp pointer" v-model="sort_by" type="radio" id="ZA" name="dropdown" value="ZA"></a>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <a class="sort-color" @click="callSortMethod('recent')">Recently Added<input class="radio-add pointer" v-model="sort_by" type="radio" id="recent" name="dropdown" value="recent"></a>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <button class="btn btn-new-primary btn-wide mr-3" v-if="leadsToShow == 'Archive' && userPermissions.leads.permitted_actions.retrieve" :style="selectedLeads.length ? '' : 'background-color: #ababab; border-color: #ababab'" @click="retriveConfirm"
                        style="padding-left: 12px !important;width: 40px !important;min-width: 3.8rem !important;">
                        <el-tooltip class="item" effect="dark" content="Revert" placement="top">
                            <i class="icon icon-arrow-down-bold-box text-white mr-2 fs-18"></i>
                        </el-tooltip>
                    </button>
                    <!-- <button class="btn btn-new-primary btn-wide px-6 mr-4" @click="$modal.show('columnConfigLeads')"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/column-config.svg" style="margin-right: 8px; margin-top: -2px"> Column Config</button> -->
                    <el-tooltip class="item" effect="dark" content="Filter" placement="top">
                        <button class="btn btn-new-primary btn-wide mr-3" @click="showFilters()" :class="{'disable-click':selectedLeads.length}" style="padding-left: 11px !important;width: 40px !important;min-width: 3.8rem !important;">
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;">
                        </button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Upload Bulk Data" placement="top">
                        <button class="btn btn-new-primary btn-wide mr-3" @click="showBulk" :class="{'disable-click':selectedLeads.length}" style="padding-left: 12px !important;width: 40px !important;min-width: 3.8rem !important;">
                            <img src="/static/images/bulk-icon.svg" style="margin-right: 8px; margin-top: -2px">
                        </button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Download Sample Excel Sheet" placement="top">
                    <button class="btn btn-new-primary btn-wide mr-3" :disabled="download_excelsheet" @click="downloadSampleExcelSheet" :class="{'disable-click':selectedLeads.length}" style="padding-left: 9px !important;width: 40px !important;min-width: 3.8rem !important;">
                        <hollow-dots-spinner v-if="download_excelsheet" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        <img src="/static/images/download_icon.png" width="22" height="22">
                    </button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Export to Excel" placement="top">
                    <button class="btn btn-new-primary btn-wide mr-3" :style="selectedLeads.length ? '' : 'background-color: #ababab; border-color: #ababab; cursor: not-allowed;'" @click="selectedLeads.length ? showDownloadExcelModal() : ''"
                        style="padding-left: 10px !important;width: 40px !important;min-width: 3.8rem !important;">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/export-excel-white.svg" style="margin-right: 8px; margin-top: -2px">
                    </button>
                </el-tooltip>
                    <button class="btn btn-new-danger btn-wide mr-3" v-if="leadsToShow != 'Converted' && loggedInUser.user_role == 'sales_manager' && userPermissions.leads.permitted_actions.delete" :style="selectedLeads.length ? '' : 'background-color: #ababab; border-color: #ababab; cursor: not-allowed;'" @click="selectedLeads.length ? $modal.show('deleteLead') : ''"
                        style="padding-left: 10px !important;width: 40px !important;min-width: 3.8rem !important;">
                        <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                            <i class="icon icon-trash fs-20 pointer text-dark-blue"></i>
                        </el-tooltip>
                    </button>
                    <button class="btn btn-new-green btn-wide mt-2 mb-2" v-if="userPermissions.leads.permitted_actions.create" @click="$router.push('/leads/createLeads/new')" :class="{'disable-click':selectedLeads.length,'create-margin':leadsToShow == 'Archive'}" style="background-color: #128807 !important;padding-left: 10px !important;width: 40px !important;min-width: 3.8rem !important;">
                        <el-tooltip class="item" effect="dark" content="Create New" placement="top">
                            <i class="icon icon-plus fw-600 fs-20 pointer text-white"></i>
                        </el-tooltip>
                    </button>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <!-- <div class="d-flex">
                    <div class="blue_header pointer">
                        <span>List View</span>
                    </div>
                    <div class="blue_header_triangle pointer"></div>
                </div> -->
                <div class="tabs tabs-style-shape">
                    <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                        <defs>
                            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                        </defs>
                    </svg>
                    <nav>
                        <ul class="ml-0">
                            <li class="tab-current">
                                <a href="javascript:;" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span>List View</span>
                                </a>
                            </li>
                            <!-- For styling we need this tag  -->
                            <li style="width: 0px !important;flex: 0 !important;">
                                <a href="#section-shape-3" style="margin: 0">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="d-flex" style="flex-grow: 1">
                    <div class="d-flex mx-4" style="flex-grow: 1;position: relative;margin-left: -20px !important;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="leads_search_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                        <input ref="searchInput" class="w-100 placeholder-text" :class="{'disable-click':selectedLeads.length}" type="text" v-model="leads_search_key" v-debounce:500ms="searchLeads" debounce-events="input" placeholder="Search by Lead Name, Company Name" style="border-radius: 20px 20px 20px 20px; padding-left: 30px;padding-right: 10px;height: 2.9em;">
                    </div>
                    <el-dropdown trigger="click" class="type-select" :class="{'disable-click':selectedLeads.length}">
                        <span class="el-dropdown-link d-flex justify-content-between w-100 px-3">
                            {{ leadsToShow }} <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey-full.svg" style="margin-right: 10px;">
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="leadsToShow = 'Manual'">Manual</el-dropdown-item>
                            <el-dropdown-item @click.native="leadsToShow = 'Archive'">Archive</el-dropdown-item>
                            <el-dropdown-item @click.native="leadsToShow = 'Converted'">Converted</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div v-if="leadsToShowStyle == 'list' && campaigns.length" class="bg-white" style="height: 2.5em"></div>
            <div v-if="leadsToShowStyle == 'list'" class="table-block pt-10" style="background-color:#fff;border-top-right-radius:5px">
                <div class="filterSelectedChips mb-3" v-if="showfilterData.lead_name.length || showfilterData.lead_source.length || showfilterData.assigned_to.length || showfilterData.lead_type.length || showfilterData.campaign_source.length || showfilterData.created_date">
                    <div class="pull-right pointer resetChips" @click="removeAllChips()"><i class="icon icon-close text-white fs-20"></i></div>
                    <div class="d-flex align-items-center flex-wrap">
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.lead_name.length">Lead Name</span>
                        <span v-for="(name,lead_index) in showfilterData.lead_name" :key="lead_index">
                            <span class="filterChips" @click="removeChips(name,'lead_name')">
                                {{name.full_name}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.lead_source.length">Lead Source</span>
                        <span v-for="(name,source_index) in showfilterData.lead_source" :key="source_index">
                            <span class="filterChips" @click="removeChips(name,'lead_source')">
                                {{name}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.assigned_to.length">Assigned To</span>
                        <span v-for="(name,assigned_index) in showfilterData.assigned_to" :key="assigned_index">
                            <span class="filterChips" @click="removeChips(name,'assigned_to')">
                                {{name.full_name}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.lead_type.length">Lead Type</span>
                        <span v-for="(name,type_index) in showfilterData.lead_type" :key="type_index">
                            <span class="filterChips text-capitalize" @click="removeChips(name,'lead_type')">
                                {{name.replaceAll('_', ' ')}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.created_date">Date</span>
                        <span class="filterChips" v-if="showfilterData.created_date" @click="removeChips(showfilterData.created_date,'created_date')">
                            {{showfilterData.created_date}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.campaign_source.length">Campaign Source</span>
                        <span v-for="(name,campaign_index) in showfilterData.campaign_source" :key="campaign_index">
                            <span class="filterChips" @click="removeChips(name,'campaign_source')">
                                {{name.campaign_source}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                    </div>
                </div>
                <div v-if="campaigns.length">
                    <div class="d-flex justify-content-center align-items-center py-8" style="background: #fff; border-radius: 5px; height: 400px;">
                        <img src="/static/images/contact-list.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                        <div class="text-center">No Lead added!</div>
                    </div>
                </div>
                <table v-else class="team-list-table w-100 table-responsive">
                    <thead>
                        <tr>
                            <th style="width: 10px !important;padding: 13px 18px !important">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" @change="selectAll" v-model="check_all_leads"/>
                                    <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </th>
                            <th v-if="leadsToShow != 'Converted' && leadsToShow != 'Archive' && userPermissions.leads.permitted_actions.edit" style="width: 10px !important;padding: 13px 18px !important"></th>
                            <th v-for="(column,index) in columnConfig" :key="index">
                                <!--<span v-on:click="setPasskey(column.value)"  class="cursor-th">
                                    <span v-if="passed_key.key == column.value && passed_key.value== -1" v-show="column.value == 'Date'" :class="{'hide-arrow': passed_key.key != column.value}" class="sorting-icon">
                                        <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                    </span>
                                    <span style="font-size: 16px !important;" v-show="column.value == 'Date'" v-else :class="{'hide-arrow': passed_key.key != column.value}" class="sorting-icon">
                                        <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                    </span>{{ column.value }}
                                </span>-->
                                <span  class="cursor-th">{{ column.value.toUpperCase() }}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="w-100" v-if="ajaxCallinprogress && !leads.length">
                            <td colspan="10">
                                <div class="d-flex w-100" v-if="ajaxCallinprogress">
                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr v-if="!ajaxCallinprogress && leads.length == 0" class="text-center font-weight-bold" style="height: 400px;">
                            <td colspan="10">
                                <img src="/static/images/contact-list.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                <div class="text-center">No Lead added!</div>
                            </td>
                        </tr>
                        <tr v-else v-for="(lead, index) in leads" :key="index">
                            <td style="width: 10px !important;padding: 13px 18px !important">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" @change="selectOne($event, lead, index)" v-model="lead.checked"/>
                                    <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </td>
                            <td v-if="leadsToShow != 'Converted' && leadsToShow != 'Archive' && userPermissions.leads.permitted_actions.edit" :class="{'disable-click':selectedLeads.length}"
                            style="width: 10px !important;padding: 13px 18px !important">
                                <div class="pointer">
                                    <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                        <button class="pointer btn-icon pt-3" style="padding:0px!important;" @click="editLead(lead.hasOwnProperty('_id') ? lead._id._id : lead.id , lead)">
                                            <img src="/static/images/images-new-theme/icons/edit.svg" height="15px;">
                                        </button>
                                    </el-tooltip>
                                </div>
                            </td>
                            <td class="text-capitalize new-blue-text pointer text-truncate cust-max-width" :title="lead.full_name" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                {{ lead.full_name || "-" }}
                            </td>
                            <td class="text-capitalize pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                {{ lead.company_name || "-" }}
                            </td>
                            <td class="text-capitalize pointer text-ellipsis" :title="lead.territory" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                {{ lead.territory || "-" }}
                            </td>
                            <td class="text-capitalize pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                {{ lead.lead_source.replace(/_/g, " ") || "-" }}
                            </td>
                            <td class="pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                {{ lead.campaign_source || "-" }}
                            </td>
                            <td class="pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                {{ convert(lead.created_time) || "-" }}
                            </td>
                            <td v-if="columnConfig.length > 6" class="pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                <span class="text-capitalize" v-if="columnConfig[6].value == 'Status'">{{ lead.lead_status || "-"  }}</span>
                                <span v-if="columnConfig[6].value == 'Lead Reference Type'">{{ "-" }}</span>
                                <span v-if="columnConfig[6].value == 'Referred By'">{{ lead.referred_by || "-" }}</span>
                                <span v-if="columnConfig[6].value == 'Location Introduced'">{{ lead.location || "-" }}</span>
                                <span v-if="columnConfig[6].value == 'Lead Type'" class="text-capitalize" :class="{'cold_lead':lead.lead_type == 'cold_lead','warm_lead':lead.lead_type == 'warm_lead','hot_lead':lead.lead_type == 'hot_lead'}">{{ lead.lead_type.replace(/_/g, " ") || "-" }}</span>
                                <span v-if="columnConfig[6].value == 'Assigned To'">{{ lead.assigned_to_name || "-" }}</span>
                                <span v-if="columnConfig[6].value == 'Industry Type'" class="text-ellipsis text-capitalize" :title="lead.industry_type">{{ lead.industry_type.replaceAll('_', ' ') ||  "-" }}</span>
                            </td>
                            <td v-if="columnConfig.length > 7" class="pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                <span class="text-capitalize" v-if="columnConfig[7].value == 'Status'">{{ lead.lead_status || "-"  }}</span>
                                <span v-if="columnConfig[7].value == 'Lead Reference Type'">{{ "-" }}</span>
                                <span v-if="columnConfig[7].value == 'Referred By'">{{ lead.referred_by || "-" }}</span>
                                <span v-if="columnConfig[7].value == 'Location Introduced'">{{ lead.location || "-" }}</span>
                                <span v-if="columnConfig[7].value == 'Lead Type'" class="text-capitalize" :class="{'cold_lead':lead.lead_type == 'cold_lead','warm_lead':lead.lead_type == 'warm_lead','hot_lead':lead.lead_type == 'hot_lead'}">{{ lead.lead_type.replace(/_/g, " ") || "-" }}</span>
                                <span v-if="columnConfig[7].value == 'Assigned To'">{{ lead.assigned_to_name || "-" }}</span>
                                <span v-if="columnConfig[7].value == 'Industry Type'" class="text-ellipsis text-capitalize" :title="lead.industry_type">{{ lead.industry_type.replaceAll('_', ' ') ||  "-" }}</span>
                            </td>
                            <td v-if="columnConfig.length > 8" class="pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                <span class="text-capitalize" v-if="columnConfig[8].value == 'Status'">{{ lead.lead_status || "-"  }}</span>
                                <span v-if="columnConfig[8].value == 'Lead Reference Type'">{{ "-" }}</span>
                                <span v-if="columnConfig[8].value == 'Referred By'">{{ lead.referred_by || "-" }}</span>
                                <span v-if="columnConfig[8].value == 'Location Introduced'">{{ lead.location || "-" }}</span>
                                <span v-if="columnConfig[8].value == 'Lead Type'" class="text-capitalize" :class="{'cold_lead':lead.lead_type == 'cold_lead','warm_lead':lead.lead_type == 'warm_lead','hot_lead':lead.lead_type == 'hot_lead'}">{{ lead.lead_type.replace(/_/g, " ") || "-" }}</span>
                                <span v-if="columnConfig[8].value == 'Assigned To'">{{ lead.assigned_to_name || "-" }}</span>
                                <span v-if="columnConfig[8].value == 'Industry Type'" class="text-ellipsis text-capitalize" :title="lead.industry_type">{{ lead.industry_type.replaceAll('_', ' ') ||  "-" }}</span>
                            </td>
                            <td v-if="columnConfig.length > 9" class="pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                <span class="text-capitalize" v-if="columnConfig[9].value == 'Status'">{{ lead.lead_status || "-"  }}</span>
                                <span v-if="columnConfig[9].value == 'Lead Reference Type'">{{ "-" }}</span>
                                <span v-if="columnConfig[9].value == 'Referred By'">{{ lead.referred_by || "-" }}</span>
                                <span v-if="columnConfig[9].value == 'Location Introduced'">{{ lead.location || "-" }}</span>
                                <span v-if="columnConfig[9].value == 'Lead Type'" class="text-capitalize" :class="{'cold_lead':lead.lead_type == 'cold_lead','warm_lead':lead.lead_type == 'warm_lead','hot_lead':lead.lead_type == 'hot_lead'}">{{ lead.lead_type.replace(/_/g, " ") || "-" }}</span>
                                <span v-if="columnConfig[9].value == 'Assigned To'">{{ lead.assigned_to_name || "-" }}</span>
                                <span v-if="columnConfig[9].value == 'Industry Type'" class="text-ellipsis text-capitalize" :title="lead.industry_type">{{ lead.industry_type.replaceAll('_', ' ') ||  "-" }}</span>
                            </td>
                            <td v-if="columnConfig.length > 10" class="pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                <span class="text-capitalize" v-if="columnConfig[10].value == 'Status'">{{ lead.lead_status || "-"  }}</span>
                                <span v-if="columnConfig[10].value == 'Lead Reference Type'">{{ "-" }}</span>
                                <span v-if="columnConfig[10].value == 'Referred By'">{{ lead.referred_by || "-" }}</span>
                                <span v-if="columnConfig[10].value == 'Location Introduced'">{{ lead.location || "-" }}</span>
                                <span v-if="columnConfig[10].value == 'Lead Type'" class="text-capitalize" :class="{'cold_lead':lead.lead_type == 'cold_lead','warm_lead':lead.lead_type == 'warm_lead','hot_lead':lead.lead_type == 'hot_lead'}">{{ lead.lead_type.replace(/_/g, " ") || "-" }}</span>
                                <span v-if="columnConfig[10].value == 'Assigned To'">{{ lead.assigned_to_name || "-" }}</span>
                                <span v-if="columnConfig[10].value == 'Industry Type'" class="text-ellipsis text-capitalize" :title="lead.industry_type">{{ lead.industry_type.replaceAll('_', ' ') ||  "-" }}</span>
                            </td>
                            <td v-if="columnConfig.length > 11" class="pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                <span class="text-capitalize" v-if="columnConfig[11].value == 'Status'">{{ lead.lead_status || "-"  }}</span>
                                <span v-if="columnConfig[11].value == 'Lead Reference Type'">{{ "-" }}</span>
                                <span v-if="columnConfig[11].value == 'Referred By'">{{ lead.referred_by || "-" }}</span>
                                <span v-if="columnConfig[11].value == 'Location Introduced'">{{ lead.location || "-" }}</span>
                                <span v-if="columnConfig[11].value == 'Lead Type'" class="text-capitalize" :class="{'cold_lead':lead.lead_type == 'cold_lead','warm_lead':lead.lead_type == 'warm_lead','hot_lead':lead.lead_type == 'hot_lead'}">{{ lead.lead_type.replace(/_/g, " ") || "-" }}</span>
                                <span v-if="columnConfig[11].value == 'Assigned To'">{{ lead.assigned_to_name || "-" }}</span>
                                <span v-if="columnConfig[11].value == 'Industry Type'" class="text-ellipsis text-capitalize" :title="lead.industry_type">{{ lead.industry_type.replaceAll('_', ' ') ||  "-" }}</span>
                            </td>
                            <td v-if="columnConfig.length > 12" class="pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                <span class="text-capitalize" v-if="columnConfig[12].value == 'Status'">{{ lead.lead_status || "-"  }}</span>
                                <span v-if="columnConfig[12].value == 'Lead Reference Type'">{{ "-" }}</span>
                                <span v-if="columnConfig[12].value == 'Referred By'">{{ lead.referred_by || "-" }}</span>
                                <span v-if="columnConfig[12].value == 'Location Introduced'">{{ lead.location || "-" }}</span>
                                <span v-if="columnConfig[12].value == 'Lead Type'" class="text-capitalize" :class="{'cold_lead':lead.lead_type == 'cold_lead','warm_lead':lead.lead_type == 'warm_lead','hot_lead':lead.lead_type == 'hot_lead'}">{{ lead.lead_type.replace(/_/g, " ") || "-" }}</span>
                                <span v-if="columnConfig[12].value == 'Assigned To'">{{ lead.assigned_to_name || "-" }}</span>
                                <span v-if="columnConfig[12].value == 'Industry Type'" class="text-ellipsis text-capitalize" :title="lead.industry_type">{{ lead.industry_type.replaceAll('_', ' ') ||  "-" }}</span>
                            </td>
                            <td v-if="columnConfig.length > 13" class="pointer" @click="leadProfileModal(lead.id)" :class="{'disable-click':selectedLeads.length}">
                                <span class="text-capitalize" v-if="columnConfig[13].value == 'Status'">{{ lead.lead_status || "-"  }}</span>
                                <span v-if="columnConfig[13].value == 'Lead Reference Type'">{{ "-" }}</span>
                                <span v-if="columnConfig[13].value == 'Referred By'">{{ lead.referred_by || "-" }}</span>
                                <span v-if="columnConfig[13].value == 'Location Introduced'">{{ lead.location || "-" }}</span>
                                <span v-if="columnConfig[13].value == 'Lead Type'" class="text-capitalize" :class="{'cold_lead':lead.lead_type == 'cold_lead','warm_lead':lead.lead_type == 'warm_lead','hot_lead':lead.lead_type == 'hot_lead'}">{{ lead.lead_type.replace(/_/g, " ") || "-" }}</span>
                                <span v-if="columnConfig[13].value == 'Assigned To'">{{ lead.assigned_to_name || "-" }}</span>
                                <span v-if="columnConfig[13].value == 'Industry Type'" class="text-ellipsis text-capitalize" :title="lead.industry_type">{{ lead.industry_type.replaceAll('_', ' ') ||  "-" }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="leadsToShowStyle == 'list' && leads.length" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                :options="pageLimit" :close-on-select="true" v-model.number="limit" :max-height="210" @close="getLeads"
                open-direction="top" :show-labels="false" placeholder="" :allow-empty="false" :searchable="false"
                style="width: 4.2em !important;padding-right: 10px!important;">
                </multiselect>
                <span class="page-info pr-2 fw-500 fs-14  pl-2 fw-500 font-size-small">Per page</span>
                <button @click="firstPage()" class="mt-1 pointer pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" class="pagination-list mt-1 ml-2 pointer" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" class="pagination-list mt-1 mr-2 pointer" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pointer pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
        <div v-show="display_filters" class="filters-background filterblock">
            <div class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
                <filter-data  :leadsToShow="leadsToShow" :showfilterData="showfilterData" @hideFilters="hideFilters" @UpdateByFilter="UpdateByFilter"></filter-data>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
         <archive-modal modal_name="archiveModal" @archiveData="archiveData" @cancelArchive="cancelArchive"></archive-modal>
        <!-- <column-config-leads modal_name="columnConfigLeads" @coloumnLeadsUpdate="coloumnLeadsUpdate"></column-config-leads> -->
        <delete-lead modal_name="deleteLead" @deleteLeads="deleteLeads"></delete-lead>
        <lead-profile-modal v-if="showLeadProfileModal" @hideLeadProfileModal="hideLeadProfileModal" @viewLead="viewLead" modal_name="lead-profile-modal" :selected_lead_id="selected_lead_id"></lead-profile-modal>
        <download-excel-modal v-if="showDownloadExcel" modal_name="downloadExcelModal" @hideDownloadExcel="hideDownloadExcel" @hideDownloadExcelAfter="hideDownloadExcelAfter" :selectedLeads="selectedLeads" :leadsToShow="leadsToShow"></download-excel-modal>
        <add-bulk-upload v-if="showBulkUpload" modal_name="bulkUpload" @hideBulkUpload="hideBulkUpload"></add-bulk-upload>
    </div>
</template>

<script>
import attachments from "./mixins/bulkAttachments"
import { EventBus } from './eventBus/nav-bar-event';
import leads from "./mixins/leads"
import convert from "./mixins/convert"
import { SweetModal } from 'sweet-modal-vue';
import ColumnConfigLeads from "./ColumnConfigLeads";
import DeleteLead from "./alertModals/DeleteLead";
import ArchiveModal from "./alertModals/ArchiveModal";
import countries from "./json/countries.json";
import { HalfCircleSpinner } from "epic-spinners";
import globals from './globals';
const FilterData = () => import("./Leads/FilterData.vue");
import LeadProfileModal from "./Leads/LeadProfileModal";
import LeadProfileDashboard from "./Leads/LeadProfileDashboard";
import DownloadExcelModal from "./Leads/DownloadExcelModal";
import AddBulkUpload from "./Leads/AddBulkUpload";
import { HollowDotsSpinner } from "epic-spinners";
export default {
    data() {
        return {
            check_all_leads: false,
            sort_by: 'recent',
            showDownloadExcel: false,
            selected_lead_id: "",
            showLeadProfileModal: false,
            warning_msg: null,
            ajaxCallinprogress: false,
            leads_search_key: '',
            search_key: "",
            leadsToShow: "Manual",
            leadsToShowStyle: "list",
            limit: 10,
            count: 0,
            skip:0,
            start: 0,
            end: 0,
            total: 0,
            filter: false,
            filtersLength: 0,
            leads: [],
            selectedLeads: [],
            leadContacts: [],
            leadSources: [
                "Conventional",
                "Social Media"
            ],
            leadCampaigns: [],
            contacts: [],
            leadStatuses: [
                "Cold Lead",
                "Hot Lead",
                "Warm Lead"
            ],
            productInterests: [],
            countries: countries,
            countriesCaps: [],
            referredBy: [],
            lead_types: [''],
            filters: {
                lead_name: [],
                lead_source: [],
                lead_type: [],
                assigned_to: [],
                campaign_source: [],
                date_range: "",
            },
            showfilterData:{
                lead_name: [],
                lead_source: [],
                lead_type: [],
                assigned_to: [],
                campaign_source: [],
                created_date: "",
            },
            isLoading: {
                leadcontactname: false,
                leadcampaignsource: false,
                contactname: false,
                productinterests: false,
                referredby: false,
            },
            columnConfig: [
            {
                order: 1,
                value: "Lead Name",
            },
            {
                order: 2,
                value: "Company Name",
            },
            {
                order: 3,
                value: "Territory",
            },
            {
                order: 4,
                value: "Lead Source",
            },
            {
                order: 5,
                value: "Campaign Source",
            },
            {
                order: 6,
                value: "Date",
            },
            {
                order: 7,
                value: "Status"
            },
            {
                order: 8,
                value: "Lead Type"
            },
            {
                order: 9,
                value: "Assigned To"
            },
            {
                order: 10,
                value: "Industry Type"
            }],
           // store_column_config: [],
            add_to_list: false,
            campaigns:[],
            pageLimit: [],
            skip_temp:0,
            temp_total:0,
            hide_filters: false,
            display_filters: false,
            passed_key: {
                key: 'id',
                value: -1
            },
            success_msg: "",
            showBulkUpload: false,
            download_excelsheet: false,
            download_url: "",
        }
    },
    mixins:[leads,convert,attachments],
    components: {
        FilterData,
        SweetModal,
        ColumnConfigLeads,
        DeleteLead,
        HalfCircleSpinner,
        ArchiveModal,
        LeadProfileModal,
        DownloadExcelModal,
        LeadProfileDashboard,
        AddBulkUpload,
        HollowDotsSpinner
    },
    methods: {
        clearSearch(){
            this.leads_search_key = ""
            this.search_key = "";
            this.$refs.searchInput.focus();
            this.getLeads();
        },
        async downloadSampleExcelSheet() {
            this.download_excelsheet = true;
            let response = await this.getExcelSheet() 
            const url = response.url;
            window.location.href = url;
            this.download_excelsheet = false
        },
        showBulk(){
            this.showBulkUpload = true;
            setTimeout(() => {
                this.$modal.show('bulkUpload')
            }, 500);
        },
        callSortMethod(sort_value){
            this.sort_by = sort_value
            if(sort_value == 'AZ'){
                this.passed_key.value = -5
            } else if(sort_value == 'ZA'){
                this.passed_key.value = -2
            } else if(sort_value == 'recent'){
                this.passed_key.value = -1
            }
            this.skip = 0
            this.getLeads();
        },
        hideBulkUpload(recall_api){
            this.showBulkUpload = false;
            if(recall_api){
                this.getLeads();
            }
        },
        hideDownloadExcel(){
            //this.selectedLeads = [];
            this.showDownloadExcel = false;
        },
        hideDownloadExcelAfter(){
            this.selectedLeads = [];
            this.leads.forEach((leads_selected) => {
                leads_selected.checked = false;
            })
            this.showDownloadExcel = false;
        },
        showDownloadExcelModal(){
            this.showDownloadExcel = true;
            setTimeout(() => {
                this.$modal.show('downloadExcelModal')
            }, 500);
        },
        hideLeadProfileModal(){
            this.showLeadProfileModal = false;
        },
        leadProfileModal(id){
            localStorage.setItem("selected_lead_id", id)
            localStorage.setItem("leads_type",this.leadsToShow == 'Manual' ? 'Manual' : this.leadsToShow == 'Archive' ? 'Archive' : 'Converted')
            this.selected_lead_id = id;
            // // let data = {
            // //     id: this.selected_lead_id,
            // };
            setTimeout(() => {
                this.$router.push(`/leads/LeadProfile_Dashboard`);
            }, 500);
        },
        //API call to get the archive data
        async archiveData(){
            if(this.selectedLeads.length){
                let params = {
                    ids: this.selectedLeads
                }
                let response = await this.convertRetrieveLeads(params)
                this.success_msg = "Leads Reverted to Manual Successfully"
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.selectedLeads = []
                    this.$refs.success_modal.close();
                    this.getLeads()
                }, 3000);
            }
        },
        //set the key for the sort key
        setPasskey: function (newKey) {
            if(newKey == 'Date'){
                newKey = 'created_time'
            }
            this.$set(this.passed_key, 'key', newKey)
            var value = this.passed_key.value == -1 ? 1 : -1
            this.$set(this.passed_key, 'value', value)
            this.getLeads()
        },
        coloumnLeadsUpdate() {
            // this.getLeads();
           // this.getColumnConfig();
        },
        //retrive confirmation modal
        retriveConfirm() {
            if(this.selectedLeads.length > 0){
                EventBus.$emit("archive_status",'retrieve')
                this.$modal.show('archiveModal')
            }
        },
        //get the one selected data
        /**@params = id */
        selectOne(event, lead, lead_index) {
            if(event.target.checked){
                let temp_id = lead.hasOwnProperty('_id') ? lead._id._id : lead.id
                this.selectedLeads.push(temp_id)
            } else {
                this.selectedLeads.forEach((selected_lead, selected_lead_index) => {
                    let temp_id = lead.hasOwnProperty('_id') ? lead._id._id : lead.id
                    if(selected_lead === temp_id){
                        this.selectedLeads.splice(selected_lead_index, 1)
                    }
                })
            }
            if(this.leads.every(x => x.checked == true)){
                this.check_all_leads = true;
            } else {
                this.check_all_leads = false;
            }
        },
        //selected multiple data
        selectAll(event) {
            if(event.target.checked === true){
                this.leads.forEach((leads_data, index) => {
                    if(this.leads[index].checked == false){
                        this.leads[index].checked = true;
                        let temp_id = leads_data.hasOwnProperty('_id') ? leads_data._id._id : leads_data.id
                        this.selectedLeads.push(temp_id)
                    }
                })
            } else {
                this.leads.forEach((lead, index) => {
                    this.leads[index].checked = false;
                })
                this.leads.forEach((leads_data, deal_list_index) => {
                    this.selectedLeads.forEach((selected_lead, selected_lead_index) => {
                        let temp_id = leads_data.hasOwnProperty('_id') ? leads_data._id._id : leads_data.id
                        if(temp_id == selected_lead){
                            this.selectedLeads.splice(selected_lead_index, 1)
                        }
                    })
                })
            }
        },
        //search the leads
        searchLeads() {
            this.skip = 0;
            this.search_key = this.leads_search_key;
            this.getLeads();
        },
        //show the filters data
        showFilters(){
            if(this.display_filters){
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        //hide the filters
        hideFilters(){
            this.hide_filters = true
            setTimeout(() => {
                this.display_filters = false
                this.hide_filters = false
            }, 500);
        },
        //remove the chips
        /**@params = value, @params = key */
        removeChips(value,key){
            let params = {
                value:value,
                key:key
            }
            EventBus.$emit('removechip',params)
        },
        removeAllChips(){
            this.filters = {
                lead_name: [],
                lead_source: [],
                lead_type: [],
                assigned_to: [],
                campaign_source: [],
                date_range: "",
            }
            this.showfilterData = {
                lead_name: [],
                lead_source: [],
                lead_type: [],
                assigned_to: [],
                campaign_source: [],
                created_date: "",
            }
            EventBus.$emit('removeAllchip')
            if(!this.display_filters) {
                this.getLeads()
            }
        },
        //update the filters
        /**@params = params */
        UpdateByFilter(params){
            this.skip = 0
            this.limit = 10
            let temp_lead_source = []
            if(params.value1.lead_source.length != 0){
                params.value1.lead_source.forEach((el) => {
                    let temp_data = el.toLowerCase().replaceAll(' ', '_')
                    temp_lead_source.push(temp_data)
                })
            }
            this.showfilterData = {
                lead_name:params.value1.lead_name,
                lead_source:params.value1.lead_source,
                assigned_to:params.value1.assigned_to,
                lead_type:params.value1.lead_type,
                created_date:params.value1.created_date,
                campaign_source:params.value1.campaign_source
            }
            this.filters = {
                lead_name:params.value.lead_name,
                lead_source:temp_lead_source,
                assigned_to:params.value.assigned_to,
                lead_type:params.value.lead_type,
                date_range:params.value.created_date,
                campaign_source:params.value.campaign_source
            }
            this.getLeads()
        },
        //view the lead by id
        /**@params = id */
        viewLead(id) {
            if(this.userPermissions.leads.permitted_actions.qualify){
                localStorage.setItem("leads_type",this.leadsToShow == 'Manual' ? 'Manual' : this.leadsToShow == 'Archive' ? 'Archive' : 'Converted')
                this.$router.push('/leads/viewLeads/' + id);
                EventBus.$emit("selectId",id)
            }
            else{
                this.$toasted.global.error("Permission Denied")
            }
        },
        //edit the lead by id
        /**@params = id , @params = value */
        editLead(id,value) {
            if(value.assigned_to_company == true){
                this.$router.push('/leads/editLeads/' + id);
            } else {
                this.$router.push('/leads/editLeadIndividual/' + id)
            }

        },
        //close the dropdown
        dropdownClosed() {
            this.search_key = "";
            this.count = 0;
        },
        //get the lead contact name
        /**@params = employee_details */
        leadContactNameLabel({employee_details}) {
            return `${employee_details.name}`;
        },
        //get the lead contact name
        /**@params = employee_details */
        contactNameLabel({employee_details}) {
            return `${employee_details.name}`;
        },
        //get the referred by label
        /**@params = employee_details */
        referredByLabel({employee_details}) {
            return `${employee_details.name}`;
        },
        //clone the lead id
        /**@params = id */
        cloneLead(id) {
            localStorage.setItem("clone", id);
            this.$router.push("/createLeads");
        },
        //Pagination
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            //this.selectedLeads = [];
            this.getLeads();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            //this.selectedLeads = [];
            this.getLeads();
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            //this.selectedLeads = [];
            this.getLeads();
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            //this.selectedLeads = [];
            this.getLeads();
        },
        //cancel arhive data
        cancelArchive(){
            //this.selectedLeads = []
        },
        //get the lead contact details
        /**@params = key */
        async getLeadContacts(key) {
            this.leadContacts = [];
            this.isLoading.leadcontactname = true;
            if (key) {
                this.search_key = key;
            }
            /**@params = skip,@params = limit,@params = search_key  */
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/shadow_employees/list/detailed", params);
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                    if (x.hasOwnProperty("employee_details")) {
                        this.leadContacts.push(x);
                    }
                });
                this.isLoading.leadcontactname = false;
            }
        },
        //get the more lead changes
        /**@params = reached */
        async getMoreLeadContacts(reached) {
            if (reached) {
                this.isLoading.leadcontactname = true;
                this.count += 1;
                /**@params = skip,@params = limit,@params = search_key  */
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key,
                };
                let res = await this.$http.post("/shadow_employees/list/detailed", params);
                if (res.data.status_id == 1) {
                    res.data.response.forEach(x => {
                        if (x.hasOwnProperty("employee_details")) {
                            this.leadContacts.push(x);
                        }
                    });
                    this.isLoading.leadcontactname = false;
                }
            }
        },
        async getLeadCampaigns() {
            this.leadCampaigns = [];
            this.isLoading.leadcampaignsource = true;
            let res = await this.$http.get("/campaign/list_campaign");
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                    this.leadCampaigns.push(x);
                });
                this.isLoading.leadcampaignsource = false;
            }
        },
        //Api call to get the list of contacts
        /**@params = key */
        async getContacts(key) {
            this.leadContacts = [];
            this.isLoading.contactname = true;
            if (key) {
                this.search_key = key;
            }
            /**@params = skip, @params = limit, @params= search_key */
            let params = {
                skip: this.count * this.limit,
                limit: this.limit,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/shadow_employees/list/detailed", params);
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                    if (x.hasOwnProperty("employee_details")) {
                        this.contacts.push(x);
                    }
                });
                this.isLoading.contactname = false;
            }
        },
        //Lazy loading of the contacts
        /**@params = reached */
        async getMoreContacts(reached) {
            if (reached) {
                this.isLoading.contactname = true;
                this.count += 1;
                /**@params = skip, @params = limit, @params= search_key */
                let params = {
                    skip: this.count * this.limit,
                    limit: this.limit,
                    search_key: this.search_key,
                };
                let res = await this.$http.post("/shadow_employees/list/detailed", params);
                if (res.data.status_id == 1) {
                    res.data.response.forEach(x => {
                        if (x.hasOwnProperty("employee_details")) {
                            this.contacts.push(x);
                        }
                    });
                    this.isLoading.contactname = false;
                }
            }
        },
        //get the leads data from settings
        async getOrganisationSettings() {
            this.ajaxCallinprogress = true;
            let res = await this.$http.get("/organisation_settings/list");
            this.lead_types=res.data.response.leads_settings.lead_type
            if (res.data.status_id == 1) {
                this.callInProgress = false;
            }
        },
        //get the products
        /**@params = key */
        async getProductInterests(key) {
            this.isLoading.productinterests = true;
            if (key) {
                this.search_key = key;
            }
            /**@params = skip, @params = limit, @params= search_key */
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/digi_products/list", params);
            if (res.data.status_id == 1) {
                this.productInterests = res.data.response;
                this.isLoading.productinterests = false;
            }
        },
        //Lazy laoding of the products
        /**@params = reached */
        async getMoreProductInterests(reached) {
            if (reached) {
                this.isLoading.productinterests = true;
                this.count += 1;
                /**@params = skip, @params = limit, @params= search_key */
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key,
                };
                let res = await this.$http.post("/digi_products/list", params);
                if (res.data.status_id == 1) {
                    res.data.response.forEach(x => {
                        this.productInterests.push(x);
                    });
                    this.isLoading.productinterests = false;
                }
            }
        },
        //Get the data of referred by
        /**@params = key */
        async getReferredBy(key) {
            this.referredBy = [];
            this.isLoading.referredby = true;
            if (key) {
                this.search_key = key;
            }
            /**@params = skip, @params = limit, @params= search_key */
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/shadow_employees/list/detailed", params);
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                    if (x.hasOwnProperty("employee_details")) {
                        this.referredBy.push(x);
                    }
                });
                this.isLoading.referredby = false;
            }
        },
        //Lazy laoding of the referred by
        /**@params = reached */
        async getMoreReferredBy(reached) {
            if (reached) {
                this.isLoading.referredby = true;
                this.count += 1;
                 /**@params = skip, @params = limit, @params= search_key */
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key,
                };
                let res = await this.$http.post("/shadow_employees/list/detailed", params);
                if (res.data.status_id == 1) {
                    res.data.response.forEach(x => {
                        if (x.hasOwnProperty("employee_details")) {
                            this.referredBy.push(x);
                        }
                    });
                    this.isLoading.referredby = false;
                }
            }
        },
        //get the leads data
        async getLeads() {
            this.ajaxCallinprogress = true;
            //this.selectedLeads = []
            this.leads = []
             /**@params = skip, @params = limit, @params = search_key, @params = limit, @params= sort_key, @params = sort_value, @params = filter_json */
            let params = {
                filter_json: this.filters,
                limit: this.limit == 0 || this.limit < 0 ? 10 : this.limit,
                skip: this.skip,
                search_key: this.search_key,
                sort_key: this.passed_key.key,
                sort_value: this.passed_key.value
            };
            //this.leads = []
            let response
            if(this.leadsToShow == 'Manual'){
                response = await this.getLeadList(params)
            }
            else if(this.leadsToShow == 'Archive'){
                response = await this.getLeadArchiveList(params)
            }
            else if(this.leadsToShow == 'Converted'){
                response = await this.getLeadConvertedList(params)
            }
           // this.leads = []
            this.leads = response.response;
            this.total = response.count;
            this.leads.forEach((per_cont, per_cont_index) => {
                this.leads[per_cont_index].checked = false;
                if(this.selectedLeads.length){
                    this.selectedLeads.forEach((selected, selected_index) => {
                        let temp_id = per_cont.hasOwnProperty('_id') ? per_cont._id._id : per_cont.id
                        if(selected === temp_id){
                            this.leads[per_cont_index].checked = true;
                        }
                    })
                }
                if(this.leads.every(x => x.checked == true)){
                    this.check_all_leads = true;
                } else {
                    this.check_all_leads = false;
                }
            })
            this.start = this.count * this.limit + 1;
            this.end = this.count * this.limit + this.limit < this.total ? this.count * this.limit + this.limit : this.total;
            this.$forceUpdate()
            this.ajaxCallinprogress = false
        },
        //APi Call to delete leads
        async deleteLeads() {
            if(this.leadsToShow == 'Draft'){
                let res = await this.$http.post("/leads/drafts/delete", {
                    _id: this.selectedLeads,
                });
                if (res.data.status_id == 1) {
                    this.$modal.hide("deleteLead");
                    this.selectedLeads = [];
                    this.getLeads();
                }
            }
            if(this.leadsToShow == 'Manual'){
                let params = {
                    id: this.selectedLeads
                }
                let response = await this.deleteLeadById(params)
                this.$modal.hide("deleteLead");
                this.selectedLeads = [];
                this.getLeads();
            }
            if(this.leadsToShow == 'Archive'){
                let params = {
                    id: this.selectedLeads
                }
                let response = await this.deleteArchiveLeadById(params)
                this.$modal.hide("deleteLead");
                this.selectedLeads = [];
                this.getLeads();
            }
        },
    },
    computed: {
        //get the skip the count
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        //get the total number of filter
        totalFilters(){
            return this.filters.date.length ? 1 + this.filters.lead_contact_name.length + this.filters.lead_source.length + this.filters.campaign_source.length + this.filters.contact_name.length + this.filters.lead_status.length + this.filters.lead_type.length + this.filters.product_interest.length + this.filters.location_introduced.length + this.filters.referred_by.length : this.filters.lead_contact_name.length + this.filters.lead_source.length + this.filters.campaign_source.length + this.filters.contact_name.length + this.filters.lead_status.length + this.filters.lead_type.length + this.filters.product_interest.length + this.filters.location_introduced.length + this.filters.referred_by.length;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
    mounted() {
        if (localStorage.hasOwnProperty("list_leads_redirection")) {
            this.leadsToShow = localStorage.getItem("list_leads_redirection");
        }
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        this.getLeads();
    },
    created() {
        //this.getLeads();
        this.countries.forEach(x => {
            this.countriesCaps.push(x.toUpperCase());
        });
        if (localStorage.hasOwnProperty("draft")) {
            this.leadsToShow = "Draft";
            localStorage.clear();
        }
    },
    beforeDestroy() {
        localStorage.removeItem('list_leads_redirection');
    },
    watch: {
        leadsToShow: function() {
            this.filters = {
                lead_name: [],
                lead_source: [],
                lead_type: [],
                assigned_to: [],
                campaign_source: [],
                date_range: "",
            }
            this.showfilterData = {
                lead_name: [],
                lead_source: [],
                lead_type: [],
                assigned_to: [],
                campaign_source: [],
                created_date: "",
            }
            EventBus.$emit('removeAllchip')
            this.getLeads();
        },
    },
}
</script>
<style scoped>
    .team-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 13px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .type-select {
        background: #fff;
        border-radius: 30px;
        height: 2.7em;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        width: 12em;
    }
    .arrow-right {
        width: 0;
        height: 0;
        border-top: 14px solid transparent;
        border-bottom: 14px solid transparent;
        border-right: 14px solid #fff;
    }
    .filter-div {
        position: fixed;
        top: 22em;
        right: 3em;
        width: 50em;
        border-radius: 7.5px;
        z-index: 9999;
    }
    .filter-head{
        white-space: nowrap;
    }
    .filter_data{
        background: #fff;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0d5be6;
        margin-right: 5px;
        white-space: nowrap;
        padding-left: 7px;
        padding-right: 7px;
    }
    .hot_lead{
        background: #fce5e5;
        color: #e82828;
        border: solid 1px #e82828;
        border-radius: 5px;
        padding: 6px 22px 6px 22px;
    }
    .warm_lead{
        background: #ffecd1;
        color: #ff9a06;
        border: solid 1px #ff9a06;
        border-radius: 5px;
        padding: 6px 12px 6px 12px;
    }
    .cold_lead{
        background: #c5daf8;
        color: #00448b;
        border: solid 1px #00448b;
        border-radius: 5px;
        padding: 6px 17px 6px 17px;
    }
    .scm-filters{
        height: 400px !important;
    }
    .text-ellipsis{
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 250px;
        width: 250px;
        display: block;
    }
    .hide-arrow {
        visibility: hidden;
    }
    th:hover .sorting-icon {
        visibility: visible !important;
        cursor: pointer;
    }
    .cust-max-width{
        max-width: 410px;
    }
    .btn-new-green{
        background-color: #00448b;
    }
    .radio-add{
        margin-left: 58px;
    }
    .radio-alp{
        margin-left: 10px;
    }
    .sort-color{
        color: #00448b !important;
    }
    .disable-click{
        pointer-events: none !important;
        cursor: not-allowed !important;
    }
    .btn {
        min-width: 5.8rem !important;
    }
    .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 510px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
    @media (min-width: 1004px) and (max-width: 1190px){
        .margin1004{
            margin-bottom: 10px !important;
        }
    }
    @media only screen and (max-width: 1003px) {
        .margin1003{
            margin-bottom: 10px !important;
            margin-top: 10px !important;
        }
    }
    @media only screen and (max-width: 876px) {
        .margin876{
            margin-bottom: 10px !important;
            margin-top: 10px !important;
        }
    }
    @media only screen and (max-width: 545px) {
        .margin545{
            margin-top: 10px !important;
        }
    }
    @media (min-width: 1004px) and (max-width: 1119px){
        .create-margin{
            margin-top: 10px !important;
        }
    }
    @media (min-width: 1191px) and (max-width: 1306px){
        .margin1306{
            margin-bottom: 10px !important;
        }
    }
    @media only screen and (max-width: 500px) {
        .dis-none{
            display: none !important;
        }
    }
    @media only screen and (min-width: 501px) {
        .dis-none-ms{
            display: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ListLeads.vue